// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__aan9B","modal_title":"ModalWindow_modal_title__2HPfN","modal_text":"ModalWindow_modal_text__6JtfC"};